import * as PIXI from "pixi.js";
import { MouseTypeContainer } from "../Shared/InteractiveContainer.js";
import { UIColors, UIPositioning } from "../Settings/UITheme.js";
export class NoteGroupMarker extends PIXI.Container {
    constructor(timeline) {
        super();
        this.timeline = timeline;
        this.y = UIPositioning.timelineHeaderHeight - NoteGroupMarker.triangleSize;
        this._leftHandle = new NoteGroupHandle();
        this._rightHandle = new NoteGroupHandle();
        this._graphics = new PIXI.Graphics();
        this.addChild(this._graphics, this._leftHandle, this._rightHandle);
    }
    reinitialise(noteGroup, y) {
        this.noteGroup = noteGroup;
        if (y != undefined) {
            this.y = y;
        }
        let [x, width] = this.timeline.getTimelineEventXWidth(this.noteGroup[0], this.noteGroup[1]);
        this.x = x + 1;
        this.redraw(width);
    }
    redraw(width) {
        let triangleSize = NoteGroupMarker.triangleSize;
        this._graphics.clear()
            .beginFill(UIColors.trackEventColor)
            .drawRect(0, triangleSize - NoteGroupMarker.lineHeight, width, NoteGroupMarker.lineHeight)
            .moveTo(0, 0).lineTo(0, triangleSize).lineTo(triangleSize, triangleSize).lineTo(0, 0)
            .moveTo(width, 0).lineTo(width, triangleSize).lineTo(width - triangleSize, triangleSize).lineTo(width, 0)
            .endFill();
    }
}
NoteGroupMarker.triangleSize = 10;
NoteGroupMarker.lineHeight = 4;
class NoteGroupHandle extends MouseTypeContainer {
    constructor() {
        super();
    }
}
//# sourceMappingURL=NoteGroupMarker.js.map